import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Grid, Card, CardContent, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import PageSalesCta from '../components/PageSalesCta';
import ChatIcon from '@mui/icons-material/Chat';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SecurityIcon from '@mui/icons-material/Security';
import { apiService } from '../services/api';

const ICONS = {
  ChatIcon: <ChatIcon sx={{ fontSize: 40 }} />,
  AnalyticsIcon: <AnalyticsIcon sx={{ fontSize: 40 }} />,
  AutoAwesomeIcon: <AutoAwesomeIcon sx={{ fontSize: 40 }} />,
  SecurityIcon: <SecurityIcon sx={{ fontSize: 40 }} />,
};

const AISolutions = () => {
  const theme = useTheme();
  const [pageData, setPageData] = useState({});
  const [aiServices, setAiServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAiSolutions = async () => {
      try {
        const data = await apiService.getAiSolutions();
        console.log('📦 AI Solutions:', data);

        setPageData(data.pageData || {});
        setAiServices(data.aiServices || []);
      } catch (error) {
        console.error('❌ Failed to load AI Solutions:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAiSolutions();
  }, []);

  if (loading)
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        Loading...
      </Box>
    );

  return (
    <Box sx={{ minHeight: '100vh', py: 8 }}>
      <Container maxWidth="lg">
        <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }}>
          <Typography variant="h2" textAlign="center" gutterBottom sx={{ color: theme.palette.primary.main }}>
            {pageData.page_title || 'AI Solutions'}
          </Typography>
          <Typography variant="h5" textAlign="center" sx={{ mb: 6, color: 'text.secondary', maxWidth: 800, mx: 'auto', lineHeight: 1.65 }}>
            {pageData.hero_subtitle ||
              'We do not sell AI slides. We ship chatbots, routing, document handling, and workflows that cut payroll hours and speed up customer replies — with clear ownership and Nairobi support.'}
          </Typography>
        </motion.div>

        {pageData.page_content && (
          <Box sx={{ mb: 6 }}>
            <div dangerouslySetInnerHTML={{ __html: pageData.page_content }} />
          </Box>
        )}

        <Grid container spacing={4} sx={{ mb: 8 }}>
          {aiServices.map((service, index) => (
            <Grid item xs={12} md={6} key={service.title}>
              <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: index * 0.1 }}>
                <Card sx={{ height: '100%', p: 3 }}>
                  <CardContent>
                    <Box sx={{ color: 'secondary.main', mb: 2 }}>{ICONS[service.icon] || <ChatIcon />}</Box>
                    <Typography variant="h5" gutterBottom sx={{ color: 'primary.main' }}>
                      {service.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
      <PageSalesCta />
    </Box>
  );
};

export default AISolutions;
